export default {
  GET_POPULAR_CONTENT_REQUESTED: 'GET_POPULAR_CONTENT_REQUESTED',
  GET_POPULAR_CONTENT_SUCCEEDED: 'GET_POPULAR_CONTENT_SUCCEEDED',
  GET_POPULAR_CONTENT_FAILED: 'GET_POPULAR_CONTENT_FAILED',
};
